import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IAllLeadsResponse, ILead } from "../models/Lead";
import { DefaultResponseWithData } from "../models/system";
import { ICustomer } from "../models/ICustomer";

export default function useCustomer() {
  const { customerPostFormData, customerPatch, get, patch } = useApiHelper();
  const queryClient = useQueryClient();

  const customer = useQuery({
    queryKey: ["customer"],
    queryFn: () => get<DefaultResponseWithData<ICustomer>>("/customer"),
    refetchInterval: 1000 * 10,
    onSuccess: (data) => {
      queryClient.setQueryData(["me"], data);
    },
  });

  const hasWilmaPro = useQuery({
    queryKey: ["customer", "hasWilmaPro"],
    queryFn: () => get<DefaultResponseWithData<boolean>>("/customer/pro"),
    refetchInterval: 1000 * 10,
  });

  const update = useMutation(
    (body: any) => patch(`/customer`, body),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["customer"] });
      },
    }
  );

  const uploadDocs = useMutation(
    (body: any) => customerPostFormData(`/customer/documents/${body.leadId}`, body),
    {
      onSuccess: () => {
      },
    }
  );

  const updateLead = useMutation(
    (body: any) => customerPatch(`/customer/lead/${body.leadId}`, body),
    {
      onSuccess: () => {
      },
    }
  );

  return {
    uploadDocs,
    updateLead,
    customer,
    update,
    hasWilmaPro
  };
}
